import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 10px;
`

export const Label = styled.label`
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 8px;
  line-height: 1.5;
`

export const Box = styled.div`
	border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 6px;
  min-height: 40px;
  max-height: 8lh;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  &:hover {
    border-color: ${({ theme }) => theme.success};
  }

  .user-item {
    padding: 4px 8px;
    background-color: #fff;
    border: 1px solid #acacac;
    border-radius: 100vmax;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    .remove-item {
      border: none;
      background: none;
      padding: 0;
      cursor: pointer;
    }
  }
`
